import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

export default makeStyles((theme) => ({
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));
